import React, { useState } from "react";
import { Box, Button, TextField, Typography, Tabs, Tab, Alert } from "@mui/material";

export default function AuthForm({ onAuth }) {
  const [tab, setTab] = useState(0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
    const url = tab === 0
        ? `${API_URL}/api/auth/login`
        : `${API_URL}/api/auth/register`;
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Unknown error");
      if (tab === 0) {
        onAuth(data.token, email);
      } else {
        setTab(0);
        setError("Registration successful! You can now log in.");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 380, mx: "auto", mt: 8, p: 4, bgcolor: "white", borderRadius: 2, boxShadow: 2 }}>
      <Tabs value={tab} onChange={(_, v) => { setTab(v); setError(""); }} centered>
        <Tab label="Login" />
        <Tab label="Register" />
      </Tabs>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        {error && <Alert severity={error.includes("success") ? "success" : "error"} sx={{ mt: 2 }}>{error}</Alert>}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 3 }}
          disabled={loading}
        >
          {tab === 0 ? "Login" : "Register"}
        </Button>
      </form>
    </Box>
  );
}
